import { useCallback, useEffect, useRef } from "react";
import { isEditableTag, resolveShortcut } from "./patientFormRules";

// Ctrl+P = ajouter un patient, Ctrl+M = ajouter un médicament,
// Ctrl+S = sauvegarder : actifs partout, y compris dans les champs.
// J maintenu + flèches = naviguer entre patients, hors champs de saisie.
export default function usePatientFormShortcuts({ addPatient, addDrugToSelected, onSave, isDirty, patientCount, setSelectedIdx }) {
    const jHeldRef = useRef(false);

    const handleKeyDown = useCallback((e) => {
        const shortcut = resolveShortcut(e);
        if (shortcut) {
            e.preventDefault();
            if (shortcut === "addPatient") addPatient();
            else if (shortcut === "addDrug") addDrugToSelected();
            else if (onSave && isDirty) onSave();
            return;
        }

        if (isEditableTag(e.target.tagName)) return;

        if (e.key === "j" || e.key === "J") {
            jHeldRef.current = true;
        } else if (e.key === "ArrowDown" && jHeldRef.current) {
            e.preventDefault();
            setSelectedIdx(i => Math.min(i + 1, patientCount - 1));
        } else if (e.key === "ArrowUp" && jHeldRef.current) {
            e.preventDefault();
            setSelectedIdx(i => Math.max(i - 1, 0));
        }
    }, [patientCount, addDrugToSelected, addPatient, isDirty, onSave, setSelectedIdx]);

    const handleKeyUp = useCallback((e) => {
        if (e.key === "j" || e.key === "J") jHeldRef.current = false;
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, [handleKeyDown, handleKeyUp]);
}
